import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { DateField } from '../components/Table/fields/DateField';
import { GuideWage } from '../types/entities/GuideWage';

export const guideWage: SchemaWithClient<GuideWage> = {
  name: 'Guide Wages',
  pluralName: 'Guide Wages',
  columns: {
    value: {
      name: 'Value',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    value_from: {
      name: 'Value From',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/guide-wages'),
};
